<script setup lang="ts">
import type { ContentBlock } from '../../../model/assessments/types'

import { AppText } from '@shared/ui/typography'

import PreviewContentText from './PreviewContentText.vue'
import PreviewContentImage from './PreviewContentImage.vue'
import PreviewContentAudio from './PreviewContentAudio.vue'

/**
 * The content blocks of a screen or activity, in order. Dispatched by `type` here rather than
 * through a registry, deliberately: `ContentBlock` is a closed three-member union, where
 * `Interaction` is the one a new type would be added to. An unknown `type` renders a stated line
 * rather than disappearing — a raw working document can hold anything.
 */
defineOptions({
  name: 'PreviewContentBlocks',
})

defineProps<{
  blocks: ContentBlock[]
}>()
</script>

<template>
  <ul class="preview-content-blocks">
    <li
      v-for="(block, index) in blocks"
      :key="`block-${index}`"
      class="preview-content-blocks__item"
    >
      <PreviewContentText
        v-if="block?.type === 'text'"
        :block="block"
      />
      <PreviewContentImage
        v-else-if="block?.type === 'image'"
        :block="block"
      />
      <PreviewContentAudio
        v-else-if="block?.type === 'audio'"
        :block="block"
      />
      <AppText
        v-else
        name="body2"
        color="slate-500"
      >
        Unsupported content block — nothing to show.
      </AppText>
    </li>
  </ul>
</template>

<style scoped lang="scss" src="./PreviewContentBlocks.scss" />
